var path = '/pages/documents/templates/views/main.tpl.html';
var html = "<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'index'\" ui-view=\"index\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'editor'\" ui-view=\"editor\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'details'\" ui-view=\"details\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/documents/templates/views/main.tpl.html
// module id = 2245
// module chunks = 1